<div class="body-app">

  <div class="login-body">
      <button class="buttonBack" (click)="goBack()" > <i class="material-icons buttonBack">navigate_before</i></button>
    <div class="login-logo-app">
        <img src="assets/images/logo-meep.png" alt="logo">
    </div>
    <form>
        <app-input [inputModel]="user.nomeInputModel" (isInputValid)="setFormStatus($event, 'name')" [(value)]="user.nome"></app-input>
        <mat-slide-toggle (change)="switchIsBrazilian()" class="isBrazilian" [checked]="true">Brasileiro</mat-slide-toggle>
        <app-input [inputModel]="user.cpfInputModel" (isInputValid)="setFormStatus($event, 'document')" [(value)]="user.cpf"></app-input>
        <app-input [inputModel]="user.emailInputModel" (isInputValid)="setFormStatus($event, 'email')" [(value)]="user.email"></app-input>
        <app-input [inputModel]="user.senhaInputModel" (isInputValid)="setFormStatus($event, 'password')" [(value)]="user.senha"></app-input>
        <app-input [inputModel]="user.confirmarSenhaInputModel" (isInputValid)="setFormStatus($event, 'confirmPassword')" [(value)]="user.confirmarSenha"></app-input>

        <mat-slide-toggle class="termsSwitch" (change)="switchTermAccepted()">
          <p class="terms">Por favor, aceite os <span class="conditions" (click)="terms()"> Termos e condições de uso</span> do app Meep.</p>
        </mat-slide-toggle>
        <div class="button-row">
          <button [disabled]="!isTermAccepted" mat-button class="buttonEnter" (click)="register()">Criar conta</button>
        </div>

    </form>
  </div>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/register/register.component.html